import { useMainStore } from "~/store";

export default defineNuxtRouteMiddleware((to, from) => {
  const currentSite = useMainStore().currentSite;
  // const ipCountry = useMainStore().ipCountry;
  // const config = useRuntimeConfig().public;

  // if (to.path.includes('/cn2-en') && ipCountry?.country && ipCountry?.country.toLowerCase() == 'cn') {
  //   window.location.href = 'cn-zh'
  // }

  if (
    currentSite &&
    currentSite.settings &&
    !currentSite.settings.test_ride_inquiry &&
    to.path.includes("test-drive")
  ) {
    throw createError({
      message: "This page could not be found.",
      statusCode: 404,
    });
  }
  if (
    currentSite &&
    currentSite.settings &&
    !currentSite.settings.become_a_partner &&
    to.path.includes("become-a-dealer")
  ) {
    throw createError({
      message: "This page could not be found.",
      statusCode: 404,
    });
  }
  if (
    currentSite &&
    currentSite.settings &&
    !currentSite.settings.become_a_partner &&
    to.path.includes('become-a-distributor')
  ) {
    throw createError({
      message: "This page could not be found.",
      statusCode: 404,
    });
  }
  if (
    currentSite &&
    currentSite.settings &&
    !currentSite.settings.work_with_us &&
    to.path.includes("work-with-us")
  ) {
    throw createError({
      message: "This page could not be found.",
      statusCode: 404,
    });
  }
});